import {
  AUTH_REQUIRED_ROUTES,
  GUEST_ONLY_ROUTES,
  LOGGED_IN_REDIRECT_PATH,
  LOGIN_REDIRECT_PATH,
  PUBLIC_ROUTES,
} from '~/utils/auth';

export default defineNuxtPlugin(() => {
  return {
    provide: {
      auth: {
        getLoginPath: (): string => {
          const localePath = useLocalePath();
          return localePath(LOGIN_REDIRECT_PATH);
        },

        getProfilePath: (): string => {
          const localePath = useLocalePath();
          return localePath(LOGGED_IN_REDIRECT_PATH);
        },

        isAuthRequired: (path: string): boolean => {
          return AUTH_REQUIRED_ROUTES.some((route) => isRouteMatch(path, route));
        },

        isGuestOnlyRoute: (path: string): boolean => {
          return GUEST_ONLY_ROUTES.some((route) => isRouteMatch(path, route));
        },

        isPublicRoute: (path: string): boolean => {
          return PUBLIC_ROUTES.some((route) => isRouteMatch(path, route));
        },

        isRouteMatch,
      },
    },
  };
});

const isRouteMatch = (currentPath: string, routePattern: string): boolean => {
  if (currentPath === routePattern) {
    return true;
  }

  const segments = currentPath.split('/').filter(Boolean);

  if (segments.length > 0 && /^[a-z]{2,5}(-[a-z]{2,5})?$/i.test(segments[0] ?? '')) {
    const pathWithoutLocale = '/' + segments.slice(1).join('/');

    if (pathWithoutLocale === routePattern) {
      return true;
    }

    if (pathWithoutLocale.startsWith(`${routePattern}/`)) {
      return true;
    }
  }

  return currentPath.startsWith(`${routePattern}/`);
};
